export const SET_ATTENDANT_LIST = "@INQUERITO/SET_ATTENDANT_LIST";
